// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '19c89b783ff88fc09a4a5af906975b2736676892';
export const BUILD_NUMBER = '249';
export const BUILD_TIMESTAMP = '2026-09-24T04:22:36.224Z';
